<template>
  <article
    class="d-flex gap-3 p-1 col-12 col-md-6 mb-3 cursor-pointer"
    v-if="props.booking"
    @click="openPanel"
  >
    <div class="image-container">
      <img :src="image" alt="lihe image" />
    </div>
    <div
      class="product-details-container d-flex flex-column justify-content-between"
    >
      <div>
        <p class="product-name body-strong mb-1">
          {{ props.booking.liheName }}
        </p>
        <p class="station-name body-strong mb-1">
          {{ props.booking.stationName }}
        </p>
      </div>
      <div>
        <p class="product-dates m-0 caption text-grey-900">
          {{ d(booking.departureDate) }} {{ t('reservations.until') }}
          {{ d(booking.returnDate) }}
        </p>
        <p class="product-paricipants m-0 caption text-grey-900">
          {{ booking.travellers.length }}
          {{ t('reservations.participant', booking.travellers.length) }}
        </p>
      </div>
    </div>
  </article>
</template>

<script lang="ts" setup>
  // Vue
  import { computed, ComputedRef, defineProps } from 'vue'

  // Configuration
  import { ModalId } from '@/config/modalIds'

  // Types
  import { BookingSummary } from '@/services/BookingService.interface'

  // Utils
  import { getImagePath } from '@/utils'

  // Store
  import { useStore } from '@/store'
  const store = useStore()

  // Translations
  import { useI18n } from 'vue-i18n'
  const { t, d } = useI18n()

  interface Props {
    booking: BookingSummary
  }

  const props = defineProps<Props>()

  // Copmuted
  const image: ComputedRef<string> = computed(() => {
    return getImagePath(props.booking.image as string)
  })

  // Methods

  const openPanel = () => {
    store.commit('modal/open', ModalId.BOOKING_PANEL)
    store.dispatch('booking/selectBooking', props.booking)
  }
</script>

<style scoped>
  img {
    width: 96px;
    height: 108px;
    border-radius: 8px;
  }
</style>
